import type { ChartImage, LivePlotImageOptions, LivePlotSizeOptions, PlotSpec, PrintChartAspect, RichSummary } from '../shared';
import type { TrajectoryAnalysis } from './trajectory';

export const APP_NAME = 'iFragmentTrajectory';
export const APP_VERSION = '1.0.2';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

export const DEFAULT_VALUES = {
  project: 'Default',
  title: 'Fragment Trajectory Simulator',
  rho0: '0.115',
  h0: '10',
  v0: '250',
  angles: '-2:2:8, 15, 35, 10:10:70, 81:1:85',
  Wt: '11',
  AD: '250',
  CD: '1',
  FS: '1.3',
  target: '100,25,60'
};

export type ChartKey = 'trajectory';

export const PRINT_CHART_ORDER: ChartKey[] = ['trajectory'];
export const PRINT_CHART_ASPECT = { trajectory: 'wide' } satisfies Record<ChartKey, PrintChartAspect>;
export const PRINT_CHART_IMAGE_OPTIONS: LivePlotImageOptions = {
  width: 1000,
  height: 620,
  scale: 2,
  layout: {
    font: { size: 15 },
    title: { font: { size: 22 } },
    margin: { l: 84, r: 30, t: 78, b: 100 },
    xaxis: { title: { font: { size: 17 } }, tickfont: { size: 13 } },
    yaxis: { title: { font: { size: 17 } }, tickfont: { size: 13 } },
    legend: { font: { size: 13 }, x: 0.5, xanchor: 'center', y: -0.25 }
  }
};

export const LIVE_PLOT_SIZE = {
  fit: 'width',
  width: '100%',
  maxWidth: '74rem',
  aspectRatio: '16 / 10',
  legendPlacement: 'plot'
} satisfies LivePlotSizeOptions;

export interface FragmentTrajectoryLiveResult {
  analysis: TrajectoryAnalysis;
  summary: RichSummary;
  plotData: Record<ChartKey, PlotSpec>;
  charts?: Partial<Record<ChartKey, ChartImage>>;
}

export interface FragmentTrajectorySavedResult {
  summary: RichSummary;
  charts: Record<ChartKey, ChartImage>;
  analysis?: never;
  plotData?: never;
}

export type FragmentTrajectoryResultState = FragmentTrajectoryLiveResult | FragmentTrajectorySavedResult;
